
  import { IResource } from "@/interfaces";
  import { Component, Vue, Prop } from "vue-property-decorator";

  @Component
  export default class ResourcesCard extends Vue {
    @Prop({ required: true }) public resource!: IResource;
  }
